<template>
<div :style="stylechat">
  <v-stepper v-model="e1" style="height:100vh;">
    <!-- <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Name of step 1</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">Name of step 3</v-stepper-step>
      </v-stepper-header> -->
    <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
      <v-col cols="1" justify="center" align="center" class="pa-0">
      </v-col>
      <v-col cols="10" justify="center" align="center" class="pa-0">
        <span class="tab-title">{{$t('Settings.editProfile.phone')}}</span>
      </v-col>
      <v-col cols="1" justify="center" align="center" class="pa-0" @click="toPage('/profile')">
        <v-icon class="fz-30">mdi-close</v-icon>
      </v-col>
    </v-layout>
    <v-divider class="mt-4 mb-2"></v-divider>
    <v-stepper-items>
      <v-stepper-content step="1">
        <span class="headerType">{{$t('Settings.messageEditPhone.MsgPhoneRegistered')}}</span>

        <p style="font-size:16px;">{{$t('Settings.messageEditPhone.MsgDetectPhone')}} {{phoneEdit}} {{$t('Settings.messageEditPhone.MsgDetectPhonenext')}}
          <!-- ตรวจพบหมายเลข {{phoneEdit}} มีการลงทะเบียนใช้งานระบบแล้ว คุณสามารถเข้าสู่ระบบอีกครั้งเพื่อใช้งานบัญชีดังกล่าวได้ทันที -->
        </p>

        <v-radio-group v-model="radios" column class="pl-3">
          <v-radio value="closeRecent">

            <template slot="label">
              <div>
                <strong style="color:black; font-size:14px;">{{$t('Settings.messageEditPhone.MsgCloseAccountSelect')}}</strong>
                <br>
                <span style="color:black; font-size:14px;">{{$t('Settings.messageEditPhone.MsgCloseAccountSpan')}} {{phoneRecent}}</span>
              </div>
            </template>
          </v-radio>
          <v-radio value="keepAccount">
            <template slot="label">
              <div>
                <strong style="color:black; font-size:14px;">{{$t('Settings.messageEditPhone.MsgKeepAccountSelect')}}</strong>
                <br>
                <span style="color:black; font-size:14px;">{{$t('Settings.messageEditPhone.MsgKeepAccountSpan')}}</span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-btn color="primary" rounded block @click="checkValue()" :disabled="disablebtnST1()">
          {{$t('AnswerQuestion.continue')}}
        </v-btn>

        <v-btn class="mt-2" block rounded color="red" dark @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>

      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card flat v-if="radios === 'closeRecent'" class="mb-5" height="200px">
          <v-layout row>
            <!-- <v-flex xs12 sm12 md12> -->
            <v-flex xs1 sm1 md1>
              <v-btn icon flat @click="e1 = 1" class="previcon">
                <v-icon style="font-size: 14px !important; cursor:pointer;">fas fa-chevron-left</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs10 sm10 md10>
              <span class="headerType">{{$t('Settings.messageEditPhone.MsgCloseOnechatAccount')}}</span>
            </v-flex>
            <!-- </v-flex> -->
          </v-layout>

          <v-flex xs12 sm12 md12>
            <p style="padding-left:26px; font-size:16px;">{{$t('Settings.messageEditPhone.MsgCloseOnechatAccountSpan')}}</p>
          </v-flex>
          <v-radio-group v-model="radios2" column class="pl-3">
            <v-radio value="closeAccount">
              <template slot="label">
                <div>
                  <span style="color:black; font-size:14px;">
                    {{$t('Settings.messageEditPhone.MsgCloseOnechatAccountSelect')}}
                  </span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card>

        <v-btn color="primary" block rounded @click="Terminate()" :disabled="disablebtnST2()">
          {{$t('AnswerQuestion.continue')}}
        </v-btn>
        <v-btn class="mt-2" block dark rounded color="red" @click="cancle()" style="color:white;">{{$t('AnswerQuestion.cancel')}}</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <span class="headerContent">{{$t('Settings.messageEditPhone.MsgConfirmCloseAccount')}}</span>
        <p style="font-size:14px; margin-bottom:0px;">{{$t('Settings.messageEditPhone.MsgSendOTP')}} {{phoneRecent}}</p>
        <p style="font-size:14px;">
          refcode :
          <v-progress-circular v-if="progressTerminate === true" :indeterminate="progressTerminate" color="grey" size="20"></v-progress-circular>
          <span v-else>{{refcode_terminate}}</span>
        </p>
        <div style="padding: 16px; padding-bottom:0px; ">
          <v-layout justify-center>
            <!-- {{ countDown }} -->
            <OtpInput ref="otpInputTerminate" input-classes="otp-input" separator="-" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChangeTerminate" @on-complete="handleOnCompleteTerminate" />
          </v-layout>
          <v-layout row class="pt-3">
            <!-- {{counting2mo}} -->
            <span v-if="counting2mo === false">{{$t('Settings.messageEditPhone.MsgOTPAgain')}}</span>
            <span v-else>{{$t('Settings.messageEditPhone.MsgOTPNotrecieve')}}</span>
            <v-icon class="pl-2" @click="newOtpmo2()" v-if="counting2mo === false" style="cursor:pointer;">mdi-refresh</v-icon>
            <v-spacer></v-spacer>
            <countdown v-if="counting2mo === true" :time="300000" @end="handleCountdownEnd2mo" :transform="transform" @progress="handleCountdownProgressmo">
              <template slot-scope="props"> {{$t('Settings.messageEditPhone.MsgResendOTP')}} {{ props.minutes }}:{{ props.seconds }} </template>
            </countdown>
          </v-layout>
        </div>
        <!-- <v-layout justify-center class="pt-2 pb-2 pl-2 pr-2"> -->
        <v-btn block rounded color="primary" :loading="loadingotpTerminate" :disabled="disableBtn()" @click="sendOTPterminate()">
          {{$t('AnswerQuestion.continue')}}
        </v-btn>
        <v-btn dark block rounded color="red" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>
        <!-- </v-layout> -->
      </v-stepper-content>
      <v-stepper-content step="4">
        <h3>{{$t('Settings.messageEditPhone.MsgVerifyPhone')}}</h3>
        <span>{{$t('Settings.messageEditPhone.MsgSendOTP')}} {{phoneEdit}}</span>
        <p style="font-size:14px;  margin-bottom:0px; ">
          refcode :
          <v-progress-circular v-if="progress === true" :indeterminate="progress" color="grey" size="20"></v-progress-circular>
          <span v-else>{{refcode_terminate}}</span>
        </p>
        <v-layout justify-center>
          <OtpInput class="pt-5 pb-2" ref="otpInput" input-classes="otp-input" separator="-" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange" @on-complete="handleOnComplete" />
        </v-layout>
        <v-layout row class="pt-3 pb-3 pl-4 pr-4">
          <span v-if="countingmo === true">{{$t('Settings.messageEditPhone.MsgOTPNotrecieve')}}</span>
          <span v-else>{{$t('Settings.messageEditPhone.MsgOTPAgain')}}</span>
          <v-icon class="pl-2" @click="newOtpmo()" v-if="countingmo === false" style="cursor:pointer;">mdi-refresh</v-icon>
          <v-spacer></v-spacer>
          <!-- 300000 -->
          <countdown v-if="countingmo === true" :time="300000" @end="handleCountdownEndmo" :transform="transform" @progress="handleCountdownProgressmo">
            <template slot-scope="props"> {{$t('Settings.messageEditPhone.MsgResendOTP')}} {{ props.minutes }}:{{ props.seconds }} </template>
          </countdown>
        </v-layout>

        <v-btn class="mt-5" block rounded :loading="loadingOtpNewno" color="primary" @click="sendOTP()" :disabled="disableBtn()">
          {{$t('AnswerQuestion.continue')}}
        </v-btn>

        <v-btn class="mt-3" block color="red" rounded dark style="color:white;" @click="cancle()">{{$t('AnswerQuestion.cancel')}}</v-btn>

        <!-- <v-btn color="primary" round block v-if="otp_off === true">ขอ otp อีกครั้ง</v-btn> -->
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</div>
</template>

<script>
import Vue from 'vue'
import {
  Decode
} from '@/services'
import OtpInput from "@bachdgvn/vue-otp-input";
import moment from 'moment'
import VueCountdown from '@chenfengyuan/vue-countdown'
Vue.component(VueCountdown.name, VueCountdown)
export default {
  components: {
    OtpInput
  },
  data: () => ({
    stylechat: {
      "--ProfileFriend-HeaderColor": "white",
      "--ProfileFriend-TabBackground": "white",
      "--ProfileFriend-Icon": "gray",
      "--ProfileFriend-IconActive": "#2662ae",
      "--ProfileFriend-Background": "white",
      "--ProfileFriend-FontSize": "18px",
      "--ProfileFriend-FontSize-Title": "24px",
      "--ProfileFriend-FontSize-Title-Edit": "20px",
      "--ProfileFriend-FontColor": "back",
      "--ProfileFriend-FontColor-Err": "#ff5252",
      "--ProfileFriend-FontSize-Status": "16px",
      "--ProfileFriend-FontColor-Status": "grey",
      "--ProfileFriend-Background-Input": "#E2E1E3",
      "--ProfileFriend-Color-Button": "#EFF2FE",
      "--ProfileFriend-FontColor-Button": "#2662ae",
      "--ProfileFriend-FontColor-Block-Button": "#cb1002",
      "--ProfileFriend-FontColor-Dis-Button": "#e2e1e3",
      "--ProfileFriend-Btn-Confirm-Background": "#2662ae",
      "--ProfileFriend-Btn-Confirm-Color": "white",
      "--ProfileFriend-Btn-Confirm-FontSize": "18px",
    },
    e1: 1,
    radios: '',
    e1: 1,
    radios2: '',
    complete: '',
    otp_off: false,
    phoneRecent: '',
    phoneEdit: '',
    refcode_terminate: '',
    countingmo: false,
    counting2mo: false,
    phonenewtologin: '',
    progress: false,
    progressTerminate: false,
    loadingOtpNewno: false,
    loadingotpTerminate: false

  }),
  computed: {
    // time () {
    //   return this.date.format('mm:ss')
    // }
  },
  created() {
    this.phoneRecent = localStorage.phonRecent,
      this.phoneEdit = localStorage.phoneEdit
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    // console.log(user_profile)
    this.token = user_profile['account']['profile']['tokenuser']
    this.progress = true
    var type_account = localStorage.typeAccount
    if (type_account === 'true') {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/otp_change_phone', {
        new_phone: localStorage.phoneEdit,
        tokenuser: this.token
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.refcode_terminate = response.data.refcode
        } else if (response.data.message === 'refresh_token expire') {
          this.progress = false
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgTokenExpire'),
            type: 'warning'
          })
        } else if (response.data.message === 'too many requests.') {
          this.refcode_terminate = ''
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
            type: 'warning'
          })
        }
        // this.refcode_terminate = response.data.refcode
      })
      this.e1 = 4
      this.countingmo = true
      // this.countdown()
    } else {
      this.e1 = 1
    }
  },
  mounted() {
    this.phonenewtologin = localStorage.phoneEdit
    this.phoneRecent = localStorage.phonRecent,
      this.phoneEdit = localStorage.phoneEdit
    // console.log(this.phonenewtologin)
    // this.phoneRecent = localStorage.phonRecent,
    // this.phoneEdit = localStorage.phoneEdit
  },
  watch: {
    // time() {
    //   if(this.date.format('mm:ss') === '00:00'){
    //     clearInterval(this.interv)
    //     this.otp_off = true
    //   }
    // },
    e1() {
      if (this.e1 === 4) {
        this.countingmo = true
      } else if (this.e1 === 3) {
        this.counting2mo = true
      }
    }
  },
  methods: {
    toPage (path) {
      this.$router.push(path)
    },
    sendOTP() {
      this.loadingOtpNewno = true
      var type_account = localStorage.typeAccount
      if (type_account === 'true') {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/confirm_otp_change_phone', {
          new_phone: localStorage.phoneEdit,
          otp: this.otpInput,
          tokenuser: this.token
        }).then((response) => {
          if (response.data.message === 'login success') {
            // this.loadingOtpNewno = false
            this.$swal({
              title: this.$t('Settings.messageEditPhone.MsgChangePhoneSuccess'),
              type: 'success',
              confirmButtonText: this.$t('AnswerQuestion.ok'),
              confirmButtonClass: 'btn btn-danger',
              buttonsStyling: true
            }).then((result) => {
              if (result) {
                this.$router.push('/profile')
                clearInterval(this.interv)
                this.date = moment(60 * 5 * 1000)
                this.$refs.otpInput.clearInput();
                this.radios = ''
                this.radios2 = ''
                localStorage.removeItem("typeAccount")
                localStorage.phone = localStorage.phoneEdit
                this.loadingOtpNewno = false
              }
            })
          } else if (response.data.message === 'OTP Invalid') {
            this.loadingOtpNewno = false
            this.$swal({
              title: this.$t('Settings.messageEditPhone.OTPInvalid'),
              type: 'error',
              confirmButtonText: this.$t('AnswerQuestion.ok'),
              confirmButtonClass: 'btn btn-danger',
              buttonsStyling: true
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        if (this.radios2 !== '') {
          // console.log('ปิด account')
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
            type: 'warning'
          }).then((result) => {
            if (result) {
              this.$router.push('/profile')
              clearInterval(this.interv)
              this.date = moment(60 * 5 * 1000)
              this.$refs.otpInput.clearInput();
              this.radios = ''
              this.radios2 = ''
              localStorage.removeItem("typeAccount")
              this.logout()
            }
          })
        }
      }
    },
    sendOTPterminate() {
      // console.log('otp terminate')
      // console.log(this.otpinput_terminate)
      this.loadingotpTerminate = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/terminate_phone', {
        phone: localStorage.phonRecent,
        otp: this.otpinput_terminate
      }).then((response) => {
        // console.log(response)
        if (response.data.message === 'terminate success') {
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
            type: 'warning',
            confirmButtonText: this.$t('AnswerQuestion.ok'),
            confirmButtonClass: 'btn btn-danger',
            buttonsStyling: true
          }).then((result) => {
            if (result) {
              this.$refs.otpInputTerminate.clearInput();
              this.loadingotpTerminate = false
              this.radios = ''
              this.radios2 = ''
              localStorage.removeItem("typeAccount")
              this.logout()
              localStorage.tologin = this.phonenewtologin
            }
          })
        } else {
          this.loadingotpTerminate = false
          this.$swal({
            title: this.$t('Settings.messageEditPhone.OTPInvalid'),
            type: 'error',
            confirmButtonText: this.$t('AnswerQuestion.ok'),
            confirmButtonClass: 'btn btn-danger',
            buttonsStyling: true
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    handleOnChange(value) {
      this.otpInput = value
      if (value.length < 6) {
        this.complete = false
      }
      // console.log('OTP changed: ', value);
    },
    handleOnComplete(value) {
      this.complete = true
    },
    handleOnChangeTerminate(value) {
      // console.log('OTP changed: ', value);
      this.otpinput_terminate = value
      if (value.length < 6) {
        this.complete = false
      }
    },
    handleOnCompleteTerminate(value) {
      // console.log('OTP completed: ', value);
      this.complete = true
    },
    Terminate() {
      this.progressTerminate = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/otp_login_and_regis', {
        phone: this.phoneRecent
      }).then((response) => {
        // console.log(response)
        if (response.data.message === 'too many requests.') {
          this.progressTerminate = false
          this.refcode_terminate = ''
          this.$swal({
            title: this.$t('Settings.messageEditPhone.MsgTooManyRequest'),
            type: 'warning',
            confirmButtonText: this.$t('AnswerQuestion.ok'),
            confirmButtonClass: 'btn btn-danger',
            buttonsStyling: true
          })
        } else if (response.data.status === 'success') {
          this.progressTerminate = false
          this.refcode_terminate = response.data.refcode
        }
        this.e1 = 3
      }).catch((err) => {
        console.log(err)
      })
    },
    checkValue() {
      if (this.radios === 'closeRecent') {
        this.e1 = 2
      } else {
        this.$swal({
          title: this.$t('Settings.messageEditPhone.MsgSwitchAccount'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          // console.log(result.value)
          if (result.value === true) {
            this.$swal({
              title: this.$t('Settings.messageEditPhone.MsgLoginPhoneAgain'),
              type: 'warning',
              confirmButtonText: this.$t('AnswerQuestion.ok'),
              confirmButtonClass: 'btn btn-danger',
              buttonsStyling: true
            }).then((result) => {
              if (result) {
                this.$router.push('/profile')
                clearInterval(this.interv)
                this.date = moment(60 * 5 * 1000)
                this.$refs.otpInput.clearInput();
                this.radios = ''
                this.radios2 = ''
                localStorage.removeItem("typeAccount")
                this.logout()
                // localStorage.tologin_keep2 = true
                localStorage.tologin = this.phonenewtologin
              }
            })
          }
        })
      }
    },
    cancle() {
      this.$swal({
        title: this.$t('Alert.Right.cancleEditPhone'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value === true) {
          this.$router.push('/profile')
          this.handleCountdownEnd2mo()
          this.handleCountdownEndmo()
          this.date = moment(60 * 5 * 1000)
          this.$refs.otpInput.clearInput();
          this.radios = ''
          this.radios2 = ''
          localStorage.removeItem("typeAccount")
        }
      })
    },
    disablebtnST1() {
      if (this.radios === '') {
        return true
      } else {
        return false
      }
    },
    disablebtnST2() {
      if (this.radios2 === '') {
        return true
      } else {
        return false
      }
    },
    disableBtn() {
      // return true
      if (this.complete === true) {
        return false
      } else {
        return true
      }
    },
    logout() {
      this.$cookie.delete('tokenuser')
      this.$cookie.delete('status_login')
      localStorage.clear()
      this.$router.push({
        path: '/login',
        force: true
      })
      // this.$router.push({
      //   path: '/login',
      //   force: true
      // })
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
    },
    newOtpmo2() {
      this.counting2mo = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/otp_login_and_regis', {
        phone: this.phoneRecent
      }).then((response) => {
        // console.log(response)
        this.refcode_terminate = response.data.refcode
        this.e1 = 3
      }).catch((err) => {
        console.log(err)
      })
    },
    newOtpmo() {
      this.countingmo = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/otp_change_phone', {
        new_phone: localStorage.phoneEdit,
        tokenuser: this.token
      }).then((response) => {
        this.refcode_terminate = response.data.refcode
      })
    },
    handleCountdownEndmo() {
      this.countingmo = false
    },
    handleCountdownEnd2mo() {
      this.counting2mo = false
    },
    handleCountdownProgressmo(data) {
      // console.log(data.days);
      // console.log(data.hours);
      // console.log(data.minutes);
      // console.log(data.seconds);
      // console.log(data.milliseconds);
      // console.log(data.totalDays);
      // console.log(data.totalHours);
      // console.log(data.totalMinutes);
      // console.log(data.totalSeconds);
      // console.log(data.totalMilliseconds);
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value < 10 ? `0${value}` : value;
        // uses singular form when the value is less than 2
        const word = value < 2 ? key.replace(/s$/, '') : key;
        props[key] = `${digits}`;
      });
      return props;
    },
  }
}
</script>

<style scoped>
.tab-title {
  color: var(--ProfileFriend-FontColor) !important;
  font-size: var(--ProfileFriend-FontSize) !important;
  font-weight: 600;
}

.tab-title-status {
  color: var(--ProfileFriend-FontColor-Status) !important;
  font-size: var(--ProfileFriend-FontSize-Status) !important;
}

.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}

>>>input.otp-input {
  width: 25px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: "center";
}

.headerType {
  font-size: 18px;
  font-weight: bold;
}

>>>.v-radio {
  align-items: flex-start;
  display: flex;
  height: auto;
  margin-right: 16px;
  outline: none;
}

>>>.previcon {
  background: transparent;
  box-shadow: none !important;
  border-radius: 50%;
  justify-content: center;
  min-width: 0;
  width: 0px !important;
  height: 12px;
}

.headerContent {
  font-size: 16px;
  font-weight: bold;
}
</style>
